export const CHANGE_PATH = "CHANGE_PATH";

export const changePath = url => ({ type: CHANGE_PATH, payload: url });



// WEBPACK FOOTER //
// ./src/actions.js